//auth 2.0
import { setEditorLastActiveBlockPosition } from "redux/actions/vdocsActions";
import store from "redux/store";
import { isTouchDevice } from "utils/utils";
import "./index.css";

export default class VideoTool {
  constructor({ data, config, api, readOnly, block }) {
    this.data = data;
    this.config = config;
    this.api = api;
    this.readOnly = readOnly;

    this.wrapper = undefined;
  }

  save() {
    return {
      videoUrl: this.data.videoUrl,
      posterUrl: this.data.posterUrl,
    };
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.className = `cdx-block video-block`;

    const video = document.createElement("video");
    video.setAttribute("blocktype", "video");
    video.setAttribute("preload", "auto");

    video.draggable = !this.readOnly && !isTouchDevice();
    video.contentEditable = false;
    if (this.data.videoUrl) {
      video.src = this.data.videoUrl;
    }

    video.addEventListener("mouseenter", () => {
      video.setAttribute("controls", "true");
    });

    video.addEventListener("mouseout", () => {
      video.removeAttribute("controls");
    });

    this.wrapper.addEventListener("click", () => {
      this.api.caret.setToBlock("start", 0);
      store.dispatch(setEditorLastActiveBlockPosition(this.api.blocks.getCurrentBlockIndex()));
    });

    video.addEventListener("seeking", () => {
      video.draggable = false;
    });

    video.addEventListener("seeked", () => {
      setTimeout(() => {
        video.draggable = !this.readOnly && !isTouchDevice();
      }, 100);
    });

    // only text selections, images, and links can be dragged.
    // For other elements, the event ondragstart must be set for drag and drop to work.
    // So I add meaningless ondragstart code to video.
    video.ondragstart = (event) => {
      event.dataTransfer.setData("text/plain", "");
    };

    this.wrapper.setAttribute("slid-cy", "editor-video-wrapper");
    video.setAttribute("slid-cy", "editor-video");
    this.wrapper.appendChild(video);
    const dummyInput = document.createElement("input");
    dummyInput.className = "dummy-input";
    this.wrapper.appendChild(dummyInput);

    return this.wrapper;
  }

  static get isReadOnlySupported() {
    return true;
  }

  static convertToPlainHTML(data) {
    return `<p> <video preload="auto"><source src=${data.videoUrl}></video></p>`;
  }
}
